<div id="register-wrapper" style="position: relative; z-index: 0; min-height: 100vh; overflow: hidden;">
<!-- Background Video -->
<video autoplay muted loop id="video-background-registration" class="position-fixed z-n1 top-0 h-100 w-100 object-fit-cover" playsinline>
    <source src="assets/videos/registration.mp4" type="video/mp4">
    Your browser does not support HTML5 video.
</video>

<!-- Background color overlay -->
<div id="color-background" class="position-absolute z-n1 top-0 h-100 w-100 bg-dark bg-opacity-25"></div>

<div class="container pt-8 text-center">
    <h1 class="text-white m-0 text-base fw-medium">Your Journey Plan</h1>
    
    <div class="max-w-lg mt-4 mx-3 mx-sm-auto p-3 rounded-pill position-relative shadow-sm">
        <div class="position-absolute z-n1 top-0 bottom-0 start-0 end-0 rounded-pill bg-dark bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-25"></div>

        <div class="plan-progress d-flex justify-content-between position-relative">
            <div class="progress-fill" id="progressFill"></div>
            <div class="step-indicator" [class.active]="currentStep >= 1" data-step="1"><i class="fas fa-user"></i></div>
            <div class="step-indicator" [class.active]="currentStep >= 2" data-step="2"><i class="fas fa-plane"></i></div>
            <div class="step-indicator" [class.active]="currentStep >= 3" data-step="3"><i class="fas fa-globe"></i></div>
            <div class="step-indicator" [class.active]="currentStep >= 4" data-step="4"><i class="fas fa-heart"></i></div>
        </div>
    </div>
</div>

<div class="container py-4">    
    <!-- Main Registration Card -->
    <div class="glass-card max-w-5xl mx-auto p-3 rounded-6 position-relative shadow-sm" id="registerCard">
        <div class="position-absolute z-n1 top-0 bottom-0 start-0 end-0 rounded-6 bg-dark bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-25"></div>
        
        <form id="registrationForm" class="px-6 py-3" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            
            <!-- STEP 1: Account Basics -->
            <div class="wizard-step" [class.active]="currentStep === 1" id="step1" [style.display]="currentStep === 1 ? 'block' : 'none'">
                <h2 class="m-0 text-base leading-7 fw-semibold text-body-emphasis">Personal Profile</h2>
                <p class="mt-1 mb-7 text-sm leading-6 text-body-tertiary">Enter your basic contact details and account security information.</p>

                <div class="row g-7">
                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="fullName">Full Name</label>
                        <input type="text" class="form-control bg-transparent border border-light border-opacity-50" id="fullName" formControlName="name">
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="username">Username</label>
                        <input type="text" class="form-control bg-transparent border border-light border-opacity-50" id="username">
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="email">Email Address</label>
                        <input type="email" class="form-control bg-transparent border border-light border-opacity-50" id="email" formControlName="email">
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="password">Password</label>
                        <input type="password" class="form-control bg-transparent border border-light border-opacity-50" id="password" formControlName="password">
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="repeatPassword">Confirm Password</label>
                        <input type="password" class="form-control bg-transparent border border-light border-opacity-50" id="repeatPassword" formControlName="repeatPassword">
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="phoneNumber">Phone Number</label>
                        <div class="input-group">
                            <select class="form-select bg-transparent border border-light border-opacity-50" style="max-width: 90px;">
                                <option class="text-dark">+1</option>
                                <option class="text-dark">+44</option>
                                <option class="text-dark">+91</option>
                            </select>
                            <input type="tel" class="form-control bg-transparent border border-light border-opacity-50" id="phoneNumber" formControlName="phone">
                        </div>
                        <div class="form-check mt-3">
                            <input class="form-check-input" type="checkbox" id="whatsappCheck" checked>
                            <label class="form-check-label text-xs text-body-tertiary" for="whatsappCheck">Enable WhatsApp for trip alerts</label>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="dateOfBirth">Date of Birth</label>
                        <input type="date" class="form-control bg-transparent border border-light border-opacity-50" id="dateOfBirth" formControlName="dob">
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="nationality">Nationality</label>
                        <select class="form-select bg-transparent border border-light border-opacity-50" id="nationality" formControlName="country">
                            <option class="text-dark" value="">Choose...</option>
                            <option class="text-dark" value="US">United States</option>
                            <option class="text-dark" value="GB">United Kingdom</option>
                            <option class="text-dark" value="CA">Canada</option>
                            <option class="text-dark" value="other">Other</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="gender">Gender <span class="text-body-tertiary text-xs">(Optional)</span></label>
                        <select class="form-select bg-transparent border border-light border-opacity-50" id="gender" formControlName="sex">
                            <option class="text-dark" value="other">Prefer not to say</option>
                            <option class="text-dark" value="man">Male: He/Him</option>
                            <option class="text-dark" value="woman">Female: She/Her</option>
                            <option class="text-dark" value="nonbinary">Non-binary: They/Them</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- STEP 2: Travel Style -->
            <div class="wizard-step" id="step2" [style.display]="currentStep === 2 ? 'block' : 'none'">
                <h2 class="m-0 text-base leading-7 fw-semibold text-body-emphasis">Travel Preferences</h2>
                <p class="mt-1 mb-7 text-sm leading-6 text-body-tertiary">Tell us about your preferred cabin class and previous flying experiences.</p>

                <div class="row g-7">
                    <div class="col-12">
                        <label class="form-label fw-medium">Preferred Travel Class</label>
                        <div class="row g-4">
                            <div class="col-12 col-sm-6 col-md-3">
                                <input type="radio" class="btn-check" name="travelClass" id="class1" autocomplete="off">
                                <label class="btn btn-outline-light w-100 py-3" for="class1">Budget Explorer</label>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                                <input type="radio" class="btn-check" name="travelClass" id="class2" autocomplete="off" checked>
                                <label class="btn btn-outline-light w-100 py-3" for="class2">Mid-range Comfort</label>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                                <input type="radio" class="btn-check" name="travelClass" id="class3" autocomplete="off">
                                <label class="btn btn-outline-light w-100 py-3" for="class3">Luxury Seeker</label>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3">
                                <input type="radio" class="btn-check" name="travelClass" id="class4" autocomplete="off">
                                <label class="btn btn-outline-light w-100 py-3" for="class4">Ultra Luxury</label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="everFlownPrivate">Ever flown Private?</label>
                        <select class="form-select bg-transparent border border-light border-opacity-50" id="everFlownPrivate">
                            <option class="text-dark">No</option>
                            <option class="text-dark">Yes</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="everFlownFirstClass">Ever flown First Class?</label>
                        <select class="form-select bg-transparent border border-light border-opacity-50" id="everFlownFirstClass">
                            <option class="text-dark">No</option>
                            <option class="text-dark">Yes</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- STEP 3: Dreams & Favorites -->
            <div class="wizard-step" id="step3" [style.display]="currentStep === 3 ? 'block' : 'none'">
                <h2 class="m-0 text-base leading-7 fw-semibold text-body-emphasis">Travel Dreams</h2>
                <p class="mt-1 mb-7 text-sm leading-6 text-body-tertiary">Share your ultimate bucket list and the destinations you love most.</p>

                <div class="row g-7">
                    <div class="col-12">
                        <label class="form-label fw-medium" for="dreamTripsForTheYear">3 Dream Trips for the Year</label>
                        <textarea class="form-control bg-transparent border border-light border-opacity-50 max-w-2xl" id="dreamTripsForTheYear" rows="4" placeholder="1. e.g., Kyoto in Spring &#10;2. e.g., Safari in Kenya &#10;3. e.g., Roadtrip in Iceland"></textarea>
                    </div>

                    <div class="col-12">
                        <label class="form-label fw-medium" for="excursionsNeverDoneBefore">3 Excursions Never Done Before</label>
                        <textarea class="form-control bg-transparent border border-light border-opacity-50 max-w-2xl" id="excursionsNeverDoneBefore" rows="4" placeholder="e.g., Deep sea diving, Skydiving..."></textarea>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="bestVacationDestination">Best Vacation Destination So Far</label>
                        <input type="text" id="bestVacationDestination" class="form-control bg-transparent border border-light border-opacity-50">
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="idealPlaceToLive">Ideal Place to Live</label>
                        <input type="text" id="idealPlaceToLive" class="form-control bg-transparent border border-light border-opacity-50">
                    </div>

                    <div class="col-12">
                        <label class="form-label fw-medium">Do you own a Vacation Property?</label>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="propertyCheck">
                            <label class="form-check-label" for="propertyCheck">Yes (Specify Type)</label>
                        </div>
                        <input type="text" class="form-control bg-transparent border border-light border-opacity-50 max-w-2xl mt-2 d-none" id="propertyType" placeholder="e.g., Beach House, Cabin...">
                    </div>
                </div>
            </div>

            <!-- STEP 4: Interests -->
            <div class="wizard-step" id="step4" [style.display]="currentStep === 4 ? 'block' : 'none'">
                <h2 class="m-0 text-base leading-7 fw-semibold text-body-emphasis">Lifestyle & Interests</h2>
                <p class="mt-1 mb-7 text-sm leading-6 text-body-tertiary">Select the activities you enjoy to help us personalize your future trips.</p>

                <div class="row g-7">
                    <div class="col-12">
                        <label class="form-label fw-medium">Activities</label>
                        <div class="d-flex flex-wrap gap-2">
                            <input type="checkbox" class="btn-check" id="int1" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int1">Winter Sports</label>
                            <input type="checkbox" class="btn-check" id="int2" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int2">Summer Sports</label>
                            <input type="checkbox" class="btn-check" id="int3" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int3">Cruises</label>
                            <input type="checkbox" class="btn-check" id="int4" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int4">Concerts</label>
                        </div>
                    </div>

                    <div class="col-12">
                        <label class="form-label fw-medium">Travel Vibes</label>
                        <div class="d-flex flex-wrap gap-2">
                            <input type="checkbox" class="btn-check" id="int5" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int5">Beach/Relax</label>
                            <input type="checkbox" class="btn-check" id="int6" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int6">Adventure</label>
                            <input type="checkbox" class="btn-check" id="int7" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int7">Food & Wine</label>
                            <input type="checkbox" class="btn-check" id="int8" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int8">Wellness</label>
                            <input type="checkbox" class="btn-check" id="int9" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int9">Cultural</label>
                            <input type="checkbox" class="btn-check" id="int10" autocomplete="off">
                            <label class="btn btn-outline-light btn-sm" for="int10">Safari</label>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="favoriteHotelChain">Favorite Hotel Chain</label>
                        <input type="text" id="favoriteHotelChain" class="form-control bg-transparent border border-light border-opacity-50" placeholder="e.g., Marriott, Hilton...">
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-medium" for="favoriteMotelChain">Favorite Motel Chain</label>
                        <input type="text" id="favoriteMotelChain" class="form-control bg-transparent border border-light border-opacity-50" placeholder="e.g., Motel 6...">
                    </div>
                </div>
            </div>

            <div class="mx-6 mt-6 text-body-tertiary opacity-50"><hr></div>

            <!-- Navigation Buttons -->
            <div class="p-6 d-flex flex-column flex-sm-row justify-content-end">
                <div class="me-sm-4 mb-4 mb-sm-0">
                    <button type="button" class="btn btn-outline-light rounded-pill w-100 px-4" [class.d-none]="currentStep === 1" (click)="prevStep()">
                        <i class="fas fa-arrow-left me-2"></i> Back
                    </button>
                </div>
                <div>
                    <button type="button" class="btn btn-primary rounded-pill w-100 px-5" [class.d-none]="currentStep === totalSteps" (click)="nextStep()">
                        Next Step <i class="fas fa-arrow-right ms-2"></i>
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-primary rounded-pill w-100 px-5" [class.d-none]="currentStep !== totalSteps" [disabled]="loading">
                        <span *ngIf="!loading">Complete Registration <i class="fas fa-check ms-2"></i></span>
                        <span *ngIf="loading"><span class="spinner-border spinner-border-sm me-2"></span>Creating account...</span>
                    </button>
                </div>
            </div>

        </form>
    </div>
    
    <div class="text-center pt-6 pb-6">
        <p class="m-0 text-body-tertiary">
            Already have an account? 
            <a routerLink="/login" class="text-white text-decoration-none fw-bold">Login here</a>
        </p>
    </div>
</div>
</div>